<template>
    <td-dialog
        v-dialogDrag
        :title="title"
        :before-close="protcolDialogClose"
        :visible.sync="dialogProtVisible"
        width="600px"
        @cancel="protcolDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="formProtInfo" ref="formProtInfo">
            <el-form-item :label="$t('common.PROTCOL_ID')" :label-width="formLabelWidth" prop="ctlProtId">
                <td-input v-model="ctlProtId" :readonly="true" :maxlength="500"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.PROTCOL_NAME')" :label-width="formLabelWidth" prop="ctlProtName">
                <td-input v-model="ctlProtName" :readonly="true" :maxlength="500"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.PROTCOL_GROUP')" :label-width="formLabelWidth" prop="ctlProtGroup">
                <td-input v-model="ctlProtGroup" :readonly="true"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.OPERATE_TYPE')" :label-width="formLabelWidth" prop="ctlOptType">
                <td-input v-model="ctlOptType" :readonly="true"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.PROTCOL_CONTROL_TYPE')" :label-width="formLabelWidth" prop="ctlType">
                <td-input v-model="ctlType" :readonly="true" :maxlength="500"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.STRUCTURAL_BODY')" :label-width="formLabelWidth" prop="ctlProtJson">
                <td-input v-model="ctlProtJson" type="textarea" :rows="6" width="450px" :readonly="true"></td-input>
            </el-form-item>
        </el-form>
    </td-dialog>
</template>
<script>
export default {
    props: ['title', 'dialogProtVisible', 'editItem'],
    created() {},
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        if (this.editItem != null) {
            this.ctlProtName = this.editItem.ctlProtName;
            this.ctlProtId = this.editItem.ctlProtId;
            this.ctlProtGroup = this.editItem.ctlGroupName;
            this.ctlOptType = this.transferProtModeType(this.editItem.protMode);
            this.ctlType = this.transferCtrlModeType(this.editItem.ctlMode);
            this.ctlProtJson = this.formatJson(this.editItem.ctlProtJson);
        } else {
            this.ctlProtName = this.$t('common.NO_DATA');
            this.ctlProtId = this.$t('common.NO_DATA');
            this.ctlProtGroup = this.$t('common.NO_DATA');
            this.ctlOptType = this.$t('common.NO_DATA');
            this.ctlType = this.$t('common.NO_DATA');
            this.ctlProtJson = this.$t('common.NO_DATA');
            this.$log.error('dialogProtVisible.editItem is null');
        }
    },
    // 定义变量
    data() {
        return {
            ctlProtId: '',
            ctlProtName: '',
            ctlProtJson: '',
            ctlProtGroup: '',
            ctlOptType: '',
            ctlType: '',
            formLabelWidth: '15%'
        };
    },
    // 定义并实现方法体
    methods: {
        // 根据id显示对应的协议模式
        transferProtModeType(protMode) {
            if (protMode == this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_CONTROL) {
                return this.$t('common.CONTROL');
            } else if (protMode == this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_DOWNLOAD) {
                return this.$t('common.DOWNLOAD');
            } else if (protMode == this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_QUERY) {
                return this.$t('common.QUERY');
            } else if (protMode == this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_UPLOAD) {
                return this.$t('common.UPLOAD');
            } else if (protMode == this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_CONFIG) {
                return this.$t('common.ALLOCATION');
            } else {
                return this.$t('common.NOT_CONFIG');
            }
        },
        // 根据id显示对应的控制模式
        transferCtrlModeType(ctlMode) {
            if (ctlMode == this.$common.deviceControlType.CTL_MODE_SIMPLE) {
                return this.$t('common.CTL_MODE_SIMPLE');
            } else if (ctlMode == this.$common.deviceControlType.CTL_MODE_DOUBLE_STREAM) {
                return this.$t('common.CTL_MODE_DOUBLE_STREAM');
            } else if (ctlMode == this.$common.deviceControlType.CTL_MODE_SERVER_STREAM) {
                return this.$t('common.CTL_MODE_SERVER_STREAM');
            } else if (ctlMode == this.$common.deviceControlType.CTL_MODE_CLIENT_STREAM) {
                return this.$t('common.CTL_MODE_CLIENT_STREAM');
            } else {
                return this.$t('common.NOT_CONFIG');
            }
        },
        formatJson(json) {
            let reg = null;
            let formatted = '';
            let pad = 0;
            let PADDING = '    ';
            let options = {};
            options.newlineAfterColonIfBeforeBraceOrBracket = options.newlineAfterColonIfBeforeBraceOrBracket === true;
            options.spaceAfterColon = options.spaceAfterColon !== false;
            if (typeof json !== 'string') {
                json = JSON.stringify(json);
            } else {
                json = JSON.parse(json);
                json = JSON.stringify(json);
            }
            reg = /([{}])/g;
            json = json.replace(reg, '$1\r\n');
            reg = /([[\]])/g;
            json = json.replace(reg, '\r\n$1\r\n');
            reg = /(,)/g;
            json = json.replace(reg, '$1\r\n');
            reg = /(\r\n\r\n)/g;
            json = json.replace(reg, '\r\n');
            reg = /\r\n,/g;
            json = json.replace(reg, ',');
            if (!options.newlineAfterColonIfBeforeBraceOrBracket) {
                reg = /:\r\n\{/g;
                json = json.replace(reg, ':{');
                reg = /:\r\n\[/g;
                json = json.replace(reg, ':[');
            }
            if (options.spaceAfterColon) {
                reg = /:/g;
                json = json.replace(reg, ':');
            }
            json.split('\r\n').forEach(function(node) {
                if (node === '') {
                    return;
                }
                let i = 0;
                let indent = 0;
                let padding = '';

                if (node.match(/\{$/) || node.match(/\[$/)) {
                    indent = 1;
                } else if (node.match(/\}/) || node.match(/\]/)) {
                    if (pad !== 0) {
                        pad -= 1;
                    }
                } else {
                    indent = 0;
                }

                for (i = 0; i < pad; i++) {
                    padding += PADDING;
                }

                formatted += padding + node + '\r\n';
                pad += indent;
            });
            return formatted;
        },
        // 关闭窗口之前需要调用的方法
        protcolDialogClose() {
            this.$emit('protcolDialogClose');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
